<template>
  <b-row class="justify-content-center">
    <b-col md="12">
      <div class="slidecontainer">
        <div :style="{'height': (customHeight ? customHeight + 'px' : '450px')}" style="overflow-y: scroll;">
          <b-row class="flex-nowrap">
            <b-col sm="12">
                <b-card style="margin-left: 20px; margin-right: 25px;">
                  <div v-if="header" slot="header">{{header}}</div>
                  <div class="text-center">
                    <p>Favoritas</p>
                    <div style="width: 50px; height: 50px; display: inline-block; margin-top: -5px;" v-for="color in favoriteColors" :key="color._id" @click="changeColor(color)" v-bind:style="{ 'background-color': (color.hex ? color.hex : '#fff') }"></div>
                  </div>
                  <br/>
                  <br/>
                  <div style="width: 50px; height: 50px; display: inline-block; margin-top: -5px;" v-for="color in colors" :key="color._id" @click="changeColor(color)" v-bind:style="{ 'background-color': (color.hex ? color.hex : '#fff') }"></div>
                </b-card>
            </b-col>
          </b-row>
        </div>
        <div v-if="admin">
          <input type="range" ref="range" @change="changeHue" min="1" max="100000" value="50000" class="slider" id="myRange">
          <p id="demo">{{hueValue}}</p>
          <input type="range" ref="range" @change="changeSaturation" min="1" max="100000" value="50000" class="slider" id="myRange">
          <p id="demo">{{saturationValue}}</p>
          <input type="range" ref="range" @change="changeBrightness" min="1" max="100000" value="50000" class="slider" id="myRange">
          <p id="demo">{{brightnessValue}}</p>
          <p>{{selectedColor._id}}</p>
          <b-row>
            <b-col sm="9">
              <b-input type="text" v-model="newHex" placeholder="#000000"></b-input>
            </b-col>
            <b-col sm="3">
              <b-button @click="updateHex">#hex</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import service from "./../service";

export default {
  name: "ColorSlider",
  props: {
    colors: Array,
    favoriteColors: Array,
    admin: false,
    header: undefined,
    customHeight: undefined
  },
  data: function() {
    return {      
      hueValue: 0,
      saturationValue: 0,
      brightnessValue: 0,
      selectedColor: {},
      newHex: ""
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    }
  },
  methods: {
    changeHue: function(e) {
      let hueValue = e.target.value;
      hueValue /= 100000;
      hueValue *= 2;
      hueValue -= 1;
      this.hueValue = hueValue;
      this.$emit('changeColor', {hueValue: this.hueValue, saturationValue: this.saturationValue, brightnessValue: this.brightnessValue});
    },
    changeSaturation: function(e) {
      let saturationValue = e.target.value;
      saturationValue /= 100000;
      saturationValue *= 2;
      saturationValue -= 1;
      this.saturationValue = saturationValue;
      this.$emit('changeColor', {hueValue: this.hueValue, saturationValue: this.saturationValue, brightnessValue: this.brightnessValue});
    },
    changeBrightness: function(e) {
      let brightnessValue = e.target.value;
      brightnessValue /= 100000;
      brightnessValue *= 2;
      brightnessValue -= 1;
      this.brightnessValue = brightnessValue;
      this.$emit('changeColor', {hueValue: this.hueValue, saturationValue: this.saturationValue, brightnessValue: this.brightnessValue});
    },
    changeColor: function(color) {
      this.selectedColor = color;
      this.hueValue = color.hue;
      this.$emit('changeColor', { id: color._id, hueValue: color.hue ? color.hue : 0, saturationValue: color.saturation ? color.saturation : 0, brightnessValue: color.brightness ? color.brightness : 0 });
    },
    updateHex: function() {
      this.selectedColor.hex = this.newHex;
      service.updateColor(this.selectedColor);
    }
  },
  created: function() {

  }
};
</script>


<style>
  .slidecontainer {
    width: 100%; /* Width of the outside container */
  }

  /* The slider itself */
  .slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 25px; /* Specified height */
    background: #d3d3d3; /* Grey background */
    outline: none; /* Remove outline */
    opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: .2s; /* 0.2 seconds transition on hover */
    transition: opacity .2s;
  }

  /* Mouse-over effects */
  .slider:hover {
    opacity: 1; /* Fully shown on mouse-over */
  }

  /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
  .slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #63c2de; /* Green background */
    cursor: pointer; /* Cursor on hover */
  }

  .slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #63c2de; /* Green background */
    cursor: pointer; /* Cursor on hover */
  }
</style>